module.exports = __webpack_public_path__ + "img/e_2_7_g.45349140.png";